const initialState = {};
const UPDATE_POLICY = 'UPDATE_POLICY';

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_POLICY:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
};

export const updatePolicy = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_POLICY,
    data
  });
};
